import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import classNames from "classnames";
import DebounceInput from "./DebounceInput";
import AwesomeIcon from "../AwesomeIcon";
import { faMagnifyingGlass, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
var DropdownMenu = function DropdownMenu(props) {
  var refer = props.refer,
    options = props.options,
    _props$Icon = props.Icon,
    Icon = _props$Icon === void 0 ? function () {
      return /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faXmark,
        className: "w-6"
      });
    } : _props$Icon,
    _props$hasArrow = props.hasArrow,
    hasArrow = _props$hasArrow === void 0 ? false : _props$hasArrow,
    _props$hasCustomContr = props.hasCustomControl,
    hasCustomControl = _props$hasCustomContr === void 0 ? false : _props$hasCustomContr,
    _props$isSearch = props.isSearch,
    isSearch = _props$isSearch === void 0 ? false : _props$isSearch,
    search = props.search,
    setSearch = props.setSearch,
    _props$menuItemClassN = props.menuItemClassName,
    menuItemClassName = _props$menuItemClassN === void 0 ? "" : _props$menuItemClassN,
    _props$scrollableCont = props.scrollableContainerClassName,
    scrollableContainerClassName = _props$scrollableCont === void 0 ? "" : _props$scrollableCont,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$childrenConten = props.childrenContent,
    childrenContent = _props$childrenConten === void 0 ? /*#__PURE__*/React.createElement(React.Fragment, null) : _props$childrenConten,
    _props$buttonClassNam = props.buttonClassName,
    buttonClassName = _props$buttonClassNam === void 0 ? "" : _props$buttonClassNam,
    _props$dataTestId = props.dataTestId,
    dataTestId = _props$dataTestId === void 0 ? "" : _props$dataTestId,
    onKeyDown = props.onKeyDown;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderOptions = function renderOptions(close) {
    return options !== null && options !== void 0 && options.length ? options === null || options === void 0 ? void 0 : options.map(function (item, index) {
      return /*#__PURE__*/React.createElement(Menu.Item, {
        key: index
      }, function (_ref) {
        var active = _ref.active;
        var className = item === null || item === void 0 ? void 0 : item.className;
        return /*#__PURE__*/React.createElement(React.Fragment, null, item !== null && item !== void 0 && item.href ? /*#__PURE__*/React.createElement("a", {
          href: item === null || item === void 0 ? void 0 : item.href,
          className: classNames("block text-gray-200 hover:bg-teal-800", _defineProperty({}, className, !!className))
        }, item === null || item === void 0 ? void 0 : item.name) : /*#__PURE__*/React.createElement("div", {
          className: classNames("block dark:text-gray-200 text-gray-800 cursor-pointer hover:bg-teal-400 dark:hover:bg-teal-800 hover:text-gray-100", _defineProperty({}, className, !!className)),
          onClick: function onClick(e) {
            var _item$onClick;
            e.stopPropagation();
            item === null || item === void 0 || (_item$onClick = item.onClick) === null || _item$onClick === void 0 || _item$onClick.call(item);
            close();
            if (setSearch) {
              setTimeout(function () {
                setSearch("");
              }, 100);
            }
          }
        }, item === null || item === void 0 ? void 0 : item.name));
      });
    }) : typeof childrenContent === "function" ? childrenContent({
      close: close
    }) : childrenContent;
  };
  return /*#__PURE__*/React.createElement(Menu, {
    as: "div",
    className: "flex-shrink-0 relative text-base"
  }, function (_ref2) {
    var open = _ref2.open,
      close = _ref2.close;
    if (!open && setSearch) {
      setTimeout(function () {
        setSearch("");
      }, 100);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Menu.Button, {
      ref: refer,
      disabled: disabled,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      className: classNames("flex group text-gray-700 dark:text-gray-200 border-b-2 relative z-10 border-transparent", _defineProperty({
        "!text-gray-100 bg-teal-900 !border-teal-500": !hasCustomControl && open,
        "dark:hover:text-gray-100 hover:bg-gray-transparent dark:hover:bg-teal-900 ": !hasCustomControl && !open,
        "border-none": isSearch,
        "opacity-50": disabled
      }, buttonClassName, !!buttonClassName)),
      "data-testid": dataTestId
    }, !!Icon && /*#__PURE__*/React.createElement(Icon, {
      open: open
    }), hasArrow && /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M16.7071 10.7071C17.0976 10.3166 17.0976 9.68342 16.7071 9.29289C16.3166 8.90237 15.6834 8.90237 15.2929 9.29289L16.7071 10.7071ZM12 14L11.2929 14.7071C11.6834 15.0976 12.3166 15.0976 12.7071 14.7071L12 14ZM8.70711 9.29289C8.31658 8.90237 7.68342 8.90237 7.29289 9.29289C6.90237 9.68342 6.90237 10.3166 7.29289 10.7071L8.70711 9.29289ZM15.2929 9.29289L11.2929 13.2929L12.7071 14.7071L16.7071 10.7071L15.2929 9.29289ZM12.7071 13.2929L8.70711 9.29289L7.29289 10.7071L11.2929 14.7071L12.7071 13.2929Z",
      fill: "white",
      fillOpacity: "0.5"
    })))), /*#__PURE__*/React.createElement(Transition, {
      as: Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95"
    }, /*#__PURE__*/React.createElement(Menu.Items, {
      className: "origin-top-right absolute z-[9999] max-h-85 ".concat(!isSearch ? "overflow-y-auto scrollbar-light dark:scrollbar" : "", " right-0 mt-3 rounded-md shadow-lg dark:bg-gray-800 bg-gray-100 focus:outline-none border border-gray-700 w-72\n                            after:content[''] after:absolute after:right-6 after:-top-4 after:bottom-auto after:border-6 after:border-transparent after:border-b-gray-700 ").concat(menuItemClassName)
    }, isSearch && /*#__PURE__*/React.createElement("div", {
      className: "flex px-4 py-3 items-center border-b border-gray-700 justify-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(DebounceInput, {
      value: search,
      onChange: setSearch,
      placeholder: t("search_templates"),
      className: "rounded-md text-white border w-full border-gray-700",
      inputClassName: "!pr-3",
      LHSIcon: /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faMagnifyingGlass,
        size: "lg",
        className: "w-5 absolute top-1/2 transform !-translate-y-1/2 left-5 cursor-pointer text-teal-500 dark:text-gray-100"
      }),
      onKeyDown: onKeyDown
    }))), isSearch ? /*#__PURE__*/React.createElement("div", {
      className: "overflow-y-auto scrollbar-light dark:scrollbar ".concat(scrollableContainerClassName)
    }, renderOptions(close)) : renderOptions(close))));
  });
};
export default DropdownMenu;